// extracted by mini-css-extract-plugin
export default {"heading":"Iy-z","corrected":"Jy-z","redirectVerbiageContainer":"Ky-z","redirectVerbiageText":"Ly-z"};